import { FlyoutMenu, mixins, SvgIcon } from '@bob/library'
import React, { FC, ReactNode } from 'react'

import * as SC from './SmileyMenu.style'

export interface SmilieMenuProps {
  children?: ReactNode
  className?: string
  loggedIn?: boolean
  showOnTop?: boolean
}

export const SmileyMenu: FC<SmilieMenuProps> = ({ children, className, loggedIn, showOnTop }) => {
  return (
    <SC.StyledHoverMenu
      as={FlyoutMenu}
      buttonElement={
        <SvgIcon
          fill={loggedIn ? mixins.colors.corporateYellow : 'none'}
          name={'PROFILE'}
          size={48}
          tabIndex={0}
        />
      }
      className={className}
      showOnTop={showOnTop}
    >
      {children}
    </SC.StyledHoverMenu>
  )
}
